import { render, staticRenderFns } from "./tixian.vue?vue&type=template&id=49376ef7&scoped=true&"
import script from "./tixian.vue?vue&type=script&lang=js&"
export * from "./tixian.vue?vue&type=script&lang=js&"
import style0 from "./tixian.vue?vue&type=style&index=0&id=49376ef7&prod&lang=less&scoped=true&"
import style1 from "./tixian.vue?vue&type=style&index=1&id=49376ef7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49376ef7",
  null
  
)

export default component.exports